import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files statically
import itCommon from './locales/it/common.json';
import itLanding from './locales/it/landing.json';
import itFaq from './locales/it/faq.json';
import itProjects from './locales/it/projects.json';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enFaq from './locales/en/faq.json';
import enProjects from './locales/en/projects.json';

// Resources object
const resources = {
  it: {
    common: itCommon,
    landing: itLanding,
    faq: itFaq,
    projects: itProjects,
  },
  en: {
    common: enCommon,
    landing: enLanding,
    faq: enFaq,
    projects: enProjects,
  },
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    // Default language is Italian
    fallbackLng: 'it',
    lng: 'it',
    
    // Resources
    resources,
    
    // Namespaces
    ns: ['common', 'landing', 'faq', 'projects'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Debug in development
    debug: process.env.NODE_ENV === 'development',

    // React options
    react: {
      useSuspense: false,
    },
  });

export default i18n;